import { Dimensions, Platform } from "react-native";
import { createPlatformStyles, theme } from "../../theme/theme";

export const { ids, styles } = createPlatformStyles({
  mobile: {
    containerStyle: {
      // width: Dimensions.get("window").width,
      alignSelf: "center",
    },
    mainContainer: {
      display: "flex",
      flex: 1,
    },
    listingContainer: {
      flex: 1,
      minHeight: Platform.select({
        ios: 300,
        android: theme.height - 200,
      }),
      alignItems: Platform.select({
        android: "center",
      }),
      justifyContent: Platform.select({
        android: "center",
      }),
    },
    heading: {
      fontFamily: theme.fontFamily.robotoSlabBold,
      color: theme.colors.text.white,
      marginTop: theme.margin.xlg,
      fontSize: theme.fontsize.xlg,
      marginBottom: theme.margin.lg,
      display: "flex",
      justifyContent: "center",
      textAlign: "center",
    },
    errorView: {
      zIndex: theme.zIndex.max,
      height: "100%",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
    },
  },
  web: {
    containerStyle: {
      width: Dimensions.get("window").width,
      alignItems: "center",
    },
    mainContainer: {
      overflow: "auto",
      position: "absolute",
      top: 70,
      bottom: 0,
      left: 0,
      right: 0,
      display: "flex",
      alignItems: "center",
    },
    listingContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    heading: {
      fontFamily: theme.fontFamily.robotoSlabBold,
      fontWeight: theme.fontweight.bold,
      color: theme.colors.text.white,
      marginTop: theme.margin.xlg,
      fontSize: theme.fontsize.xl,
      marginBottom: theme.margin.lg,

      display: "flex",
      justifyContent: "center",
      textAlign: "center",
    },
    errorView: {
      zIndex: theme.zIndex.max,
      bottom: 0,
      height: "100%",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
    },
    policyListWebView: {
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "center",
      // justifyContent: "left",
      // marginLeft: theme.spacing.sxlg, temp
    },
  },
});
